import { Button, Divider, Flex, Text } from '@mantine/core';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useDealEventFeed } from '@dealstack/frontend/app/pages/Project/DealEventLog/useDealEventFeed.ts';
import { DealEventRow } from '@dealstack/frontend/app/pages/Project/DealEventLog/DealEventRow.tsx';
import { useMarkDealEventLogViewed } from '@dealstack/frontend/app/pages/Project/DealEventLog/useMarkDealEventLogViewed.ts';
import { GENERIC_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds.ts';
import { firstSeenEventIndex } from '@dealstack/frontend/app/pages/Project/DealEventLog/dealEventLog.utils.ts';

export const DealEventLogCurrent = () => {
	const tCapManage = useTranslationCapManage();
	const { dealId } = useRequiredParams('dealId');
	const { events, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } =
		useDealEventFeed(dealId);
	const { previousViewedAt } = useMarkDealEventLogViewed(dealId);
	const firstSeenIndex = firstSeenEventIndex(events, previousViewedAt);

	return (
		<Flex direction="column" gap="0.5rem" p="1.5rem" h="100%" style={{ overflowY: 'auto' }}>
			<Text size="lg" fw={600}>
				{tCapManage('deal_event_log.title')}
			</Text>

			{isLoading && <InlineLoader />}

			{!isLoading && !events.length && (
				<Text c="dimmed">{tCapManage('deal_event_log.empty')}</Text>
			)}

			{events.map((event, index) => (
				<div key={event.id}>
					{index > 0 && index === firstSeenIndex && (
						<Divider
							color="blue"
							labelPosition="left"
							label={tCapManage('deal_event_log.seen_marker')}
							data-testid={GENERIC_ELEMENT_ID.DEAL_EVENT_LOG_SEEN_MARKER}
						/>
					)}
					{index > 0 && index !== firstSeenIndex && <Divider />}
					<DealEventRow event={event} dealId={dealId} />
				</div>
			))}

			{!isLoading && !hasNextPage && (
				<Text size="sm" c="dimmed">
					{tCapManage('deal_event_log.auth.recorded_since_ship')}
				</Text>
			)}

			{hasNextPage && (
				<Button
					variant="subtle"
					loading={isFetchingNextPage}
					onClick={() => void fetchNextPage()}
					style={{ alignSelf: 'flex-start' }}
				>
					{tCapManage('deal_event_log.load_more')}
				</Button>
			)}
		</Flex>
	);
};
